import ClaimProviderDetail from '../../components/ClaimProviderDetail';

const ClaimProviderDetailsPage = () => {
  return <ClaimProviderDetail />;
};

export default ClaimProviderDetailsPage;
